import React from 'react'
import { Helmet } from 'react-helmet-async'
import { AuthLayout } from './auth-layout'
import { SignInForm } from './sign-in-form'

function SignIn() {
  return (
    <>
    <Helmet><title>BVT - Login</title></Helmet>
    <AuthLayout>
        <SignInForm/>
    </AuthLayout>
    </>
  )
}

export default SignIn